import { useState, useEffect } from 'react';
import { SellerBusinessInfoPage } from './auth/SellerBusinessInfoPage';
import { DesktopSellerBusinessInfoPage } from './desktop/DesktopSellerBusinessInfoPage';

export function ResponsiveSellerBusinessInfoPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <SellerBusinessInfoPage /> : <DesktopSellerBusinessInfoPage />;
}